import "../css/FormOffer.css";
import _ from "lodash";
import React from "react";
import PropTypes from "prop-types";
import ChevronRight from "../svg/ICON_chevronRight_Dark.svg";
import {
  Form,
  Input,
  Label,
  Submit,
  ErrorAlert,
  ErrorHolder,
} from "elza-react";
import ProductSelect from "./ProductSelect";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
const fields = {
  client: [
    { fieldname: "Lastname", name: "Nom", requis: true },
    { fieldname: "Firstname", name: "Prénom", requis: false },
    { fieldname: "Company", name: "Société", requis: false },
    { fieldname: "Address", name: "Adresse", requis: true },
    { fieldname: "PostalCode", name: "NPA", requis: true },
    { fieldname: "Locality", name: "Localité", requis: true },
    { fieldname: "Country", name: "Pays", requis: false },
    { fieldname: "Phone", name: "Téléphone", requis: true },
    { fieldname: "Email", name: "Email", requis: true },
  ],
  chantier: [
    { fieldname: "SiteName", name: "Nom", requis: false },
    { fieldname: "SiteNumber", name: "N° de chantier", requis: false },
    { fieldname: "SiteAddress", name: "Adresse", requis: false },
    { fieldname: "SitePostalCode", name: "NPA", requis: false },
    { fieldname: "SiteLocality", name: "Localité", requis: false },
    {
      fieldname: "SiteDate",
      name: "Date prévue de début des travaux",
      requis: false,
    },
  ],
};

/**
 * FormOffer component
 */
class FormOffer extends React.Component {
  static displayName = "FormOffer";
  static propTypes = {
    className: PropTypes.string,
    stores: PropTypes.object.isRequired,
    screen: PropTypes.string.isRequired,
  };
  static defaultProps = {};

  /**
   * @constructor
   * @param {Object} props
   */
  constructor(props) {
    super(props);
    this.className = "FormOffer";
    this.state = {
      mounted: false,
    };
    this.recaptcha = null;
    _.bindAll(this, "submit", "validations");
  }

  /**
   * @param  {FormData} formData
   */
  submit(formElement, formData) {
    if (formData.errors.any()) return; // Nothing to do here
    const data = new FormData(formElement);
    return axios.post("/new-offer/post_offer", data).then(
      (response) => {
        alert("Votre demande de contact a été envoyée", response.status);
        window.location.reload();
        formData.errors.clear();
        if (!_.isNil(this.recaptcha)) this.recaptcha.reset();
        return Promise.resolve();
      },
      (xhr) => {
        console.error("can not save response", xhr);
        if (_.has(xhr, "response.data.error")) {
          formData.errors.add(
            "offer.ServerError",
            _.get(xhr, "response.data.error")
          );
          setTimeout(() => {
            formData.errors.clear();
            if (!_.isNil(this.recaptcha)) this.recaptcha.reset();
          }, 5500);
        } else if (_.has(xhr, "response.data.errors")) {
          formData.errors.add(
            "offer.ServerError",
            _.join(
              _.get(xhr, "response.data.errors").map((error) => error.message),
              ". "
            )
          );
          setTimeout(() => {
            formData.errors.clear();
            if (!_.isNil(this.recaptcha)) this.recaptcha.reset();
          }, 5500);
        } else if (_.has(xhr, "response.statusText")) {
          formData.errors.add(
            "offer.ServerError",
            _.get(xhr, "response.statusText")
          );
          setTimeout(() => {
            formData.errors.clear();
            if (!_.isNil(this.recaptcha)) this.recaptcha.reset();
          }, 5500);
        } else {
          console.error("Unknown error", xhr);
        }
        return false;
      }
    );
  }

  /**
   * Wich fields we need to validate
   * @return {Array<Array<String|Function>>}
   */
  validations() {
    return [
      [
        // All fields that are required (presence validator.)
        ...fields.client
          .filter((field) => field.requis)
          .map((field) => "offer." + field.fieldname),
        ...fields.chantier
          .filter((field) => field.requis)
          .map((field) => "offer." + field.fieldname),
        "offer.OfferConditions",
        (fieldValue, fieldName, formData) => {
          if (_.isEmpty(fieldValue)) {
            formData.errors.add(fieldName, "blank");
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }
        },
      ],
      [
        "g-recaptcha-response",
        (fieldValue, fieldName, formData) => {
          if (_.isEmpty(fieldValue)) {
            formData.errors.add(
              "offer.recaptcha",
              "Veuillez confirmer que vous n'êtes pas un robot"
            );
            setTimeout(() => {
              formData.errors.clear();
            }, 3500);
          }
        },
      ],
      [
        "offer.Email",
        (fieldValue, fieldName, formData) => {
          const reg = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
          if (reg.test(fieldValue) !== true) {
            formData.errors.add(fieldName, "bad_format");
            window.scroll({
              top: 0,
              left: 0,
              behavior: "smooth",
            });
          }
        },
      ],
    ];
  }

  /**
   * @override
   */
  render() {
    return (
      <div className={`${this.className} ${this.props.className || ""}`}>
        <Form
          name="offer"
          validations={this.validations()}
          submit={this.submit}
          method="post"
          action="/new-offer/post_offer"
          encType="multipart/form-data"
          ref={(ref) => {
            if (!this.state.mounted) this.setState({ mounted: true });
          }}
        >
          <h2>Demande d'offre</h2>
          <div className={`${this.className}__tip`}>
            <div>* Champs requis</div>
            <ErrorAlert htmlFor="offer">
              <div
                style={{ color: "red", fontSize: "14px", marginLeft: "1rem" }}
              >
                Veuillez remplir le champ requis !
              </div>
            </ErrorAlert>
          </div>
          <h2>Client</h2>
          <div className={`${this.className}__fields`}>
            {fields.client.map((field, index) => {
              return (
                <div key={index} className={`${this.className}__field`}>
                  <Label
                    className={`${this.className}__label`}
                    htmlFor={`offer.${field.fieldname}`}
                  >{`${field.name}${field.requis ? "*" : ""}`}</Label>
                  <Input
                    type="text"
                    className={`${this.className}__input`}
                    name={`offer.${field.fieldname}`}
                  />
                </div>
              );
            })}
          </div>
          <h2>Chantier</h2>
          <div className={`${this.className}__fields`}>
            {fields.chantier.map((field, index) => {
              return (
                <div key={index} className={`${this.className}__field`}>
                  <Label
                    htmlFor={`offer.${field.fieldname}`}
                    className={`${this.className}__label`}
                  >{`${field.name}${field.requis ? "*" : ""}`}</Label>
                  <Input
                    type="text"
                    className={`${this.className}__input`}
                    name={`offer.${field.fieldname}`}
                  />
                </div>
              );
            })}
          </div>
          <h2>Demande d'offre</h2>
          <div className={`${this.className}__fields`}>
            <div className={`${this.className}__field`}>
              <div className={`${this.className}__label`}>
                Demande d'offre pour
              </div>
              <Input
                id="r-offer-1"
                type="radio"
                name="offer.OfferType"
                value="soumission"
                className={`${this.className}__input`}
              />
              <label htmlFor="r-offer-1">
                <span />
                Soumission
              </label>
              <Input
                id="r-offer-2"
                type="radio"
                name="offer.OfferType"
                value="adjudication"
                className={`${this.className}__input`}
              />
              <label htmlFor="r-offer-2">
                <span />
                Adjudication
              </label>
            </div>
            {
              <ProductSelect
                products={this.props.stores.page.pages.ProductPage.map(
                  (productPage) => productPage.productCategories()
                ).flatten(true)}
              />
            }
            <div className={`${this.className}__field no-vertical-align`}>
              <Label
                htmlFor="offer.OfferComment"
                className={`${this.className}__label`}
              >
                Remarques
              </Label>
              <textarea
                name="offer.OfferComment"
                className={`${this.className}__textarea`}
                placeholder="par exemple : restriction pour l’accessibilité au chantier pour certains types de camions"
              />
            </div>
            <div className={`${this.className}__field no-vertical-align`}>
              <Label
                htmlFor="offer.Attachements[]"
                className={`${this.className}__label`}
              >
                Pièces jointes
              </Label>
              <textarea
                name="offer.AttachementComment"
                className={`${this.className}__textarea file`}
                placeholder="par exemple : pages de soumission, plan d’accès au chantier, etc."
              />
              <div className={`${this.className}__filefield`}>
                <input
                  accept={
                    this.props.screen !== "desktop"
                      ? "image/jpeg,image/png"
                      : "image/jpeg,image/gif,image/png,application/pdf,.docx,.doc"
                  }
                  id="capture"
                  type="file"
                  name="offer.Attachements[]"
                  className={`${this.className}__input`}
                  multiple
                />
                <div className={`${this.className}__filetip`}>
                  (La taille des fichiers est limitée à 5mo)
                </div>
              </div>
            </div>
            <div className={`${this.className}__footer`}>
              <a
                href="/conditions-generales/"
                target="_blank"
                rel="noopener noreferrer"
                className={`${this.className}__link`}
              >
                Conditions générales de livraison des granulats
                <img src={ChevronRight} alt=">" className="icon" />
              </a>
              <div className={`${this.className}__field`}>
                <Input
                  type="checkbox"
                  name="offer.OfferConditions"
                  id="offer.OfferConditions"
                  className={`${this.className}__input`}
                  value="1"
                />
                <Label htmlFor="offer.OfferConditions">
                  <span />
                  J’ai pris connaissance et accepte les conditions générales de
                  livraison de granulats
                </Label>
              </div>
              <div className={`${this.className}__recaptcha`}>
                <ReCAPTCHA
                  ref={(recaptcha) => (this.recaptcha = recaptcha)}
                  sitekey="6LfymSQUAAAAAMLC2Q4jDmAb45PePtZylylihGyQ"
                  size="normal"
                />
              </div>
            </div>
          </div>
          <ErrorHolder htmlFor="offer.ServerError" />
          <ErrorHolder htmlFor="offer.recaptcha" />

          <Submit htmlFor="offer" className={`${this.className}__submit`}>
            Envoyer message
            <img src={ChevronRight} className="icon" alt=">" />
          </Submit>
        </Form>
      </div>
    );
  }
}

export default FormOffer;



// WEBPACK FOOTER //
// ./src/components/FormOffer.js